/**
 * @typedef {Record<string, {
 *   name: string,
 *   icon: string,
 *   msg: string,
 *   plans: {
 *     type: string,
 *     months: number,
 *     price: string,
 *     monthly: string,
 *     url: string
 *   }[]
 * }>} SubscriptionMap
 */

/**
 * @var {SubscriptionMap} subscriptions
 */


function updatePrice(processorKey) {
    /** @type {HTMLSelectElement} */
    const select = document.getElementById('select-' + processorKey);
    const priceDisplay = document.getElementById('price-' + processorKey);
    const monthlyPriceDisplay = document.getElementById('monthly-' + processorKey);
    const plan = subscriptions[processorKey].plans[select.selectedIndex];
    priceDisplay.innerHTML = plan.price;
    monthlyPriceDisplay.innerHTML = plan.monthly+(plan.months > 1? '/'+i18next.t('subscribe.month'):'');
    if(processorKey === 'paypal'){
        document.querySelector('.paypal-btn.show').classList.remove('show');
        document.getElementById('paypal-'+select.selectedIndex).classList.add('show');
    }
}

function subscribe(processorKey) {
    /** @type {HTMLSelectElement} */
    const select = document.getElementById('select-' + processorKey);
    const url = subscriptions[processorKey].plans[select.selectedIndex].url;
    if (url) {
        window.open(url, '_blank');
    }
}